import { get } from 'lodash';
import apiClient from './api-client.service';

export class KaiService {
    constructor(private apiClients = apiClient) {
        this.apiClients = apiClient;
    }

    private getReadableErrorMessage(status: number, data: any): string {
        if (!data) {
            return `Error ${status}: Something went wrong`;
        }

        if (Array.isArray(data?.detail)) {
            return `Error ${status}: ${data.detail
                .map((item: { msg?: string; message?: string }) => item?.msg || item?.message)
                .filter(Boolean)
                .join(', ')}`;
        }

        return `Error ${status}: ${
            data?.message || data?.error?.message || data?.detail || data?.error || JSON.stringify(data)
        }`;
    }

    private extractReply(data: any, fallbackText = ''): string {
        return (
            get(data, 'choices[0].message.content') ||
            get(data, 'choices[0].delta.content') ||
            get(data, 'choices[0].text') ||
            get(data, 'output_text') ||
            get(data, 'reply') ||
            get(data, 'message') ||
            get(data, 'response') ||
            get(data, 'data.reply') ||
            get(data, 'data.message') ||
            get(data, 'data.response') ||
            fallbackText ||
            'No response'
        );
    }

    async sendMessage(message: string, previousResponseId?: string): Promise<{ reply: string; responseId?: string }> {
        const apiKey = import.meta.env.VITE_KPAW_API_KEY as string;
        const apiUrl = import.meta.env.VITE_KPAW_API_URL as string;

        if (!apiKey || !apiUrl) {
            return { reply: 'Chat configuration missing. Please check VITE_KPAW_API_KEY and VITE_KPAW_API_URL.' };
        }

        try {
            const body: Record<string, unknown> = { message };

            if (previousResponseId) {
                // Server-side conversation state — Foundry chains from the prior turn.
                body['previous_response_id'] = previousResponseId;
            }

            const response = await this.apiClients.post(apiUrl, body, {
                skipLoader: true,
                headers: {
                    /* eslint-disable @typescript-eslint/naming-convention */
                    'Content-Type': 'application/json',
                    /* eslint-disable @typescript-eslint/naming-convention */
                    'api-key': apiKey,
                },
            });

            return {
                reply: this.extractReply(response?.data, response?.data),
                responseId: get(response?.data, 'response_id'),
            };
        } catch (error: any) {
            const status = error?.response?.status;
            const data = error?.response?.data;

            if (status) {
                return { reply: this.getReadableErrorMessage(status, data) };
            }

            throw error;
        }
    }
}
